export class Tax {
    id: string;
    name: string;
    status: string;
    category: string;
    calc_method: string;
    tax_amount: string;
    from_date: string;
    to_date: string;
    max_free: string;
    tax_period: string;
    row_id: string;
    creation_user: string;
    creation_ip: string;
    created_at: string;
    showDeletedOnly: boolean;

    constructor() {

    }
}



// WEBPACK FOOTER //
// ./src/app/views/setting/taxes/tax.ts